<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Get Student Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @change="getStud()"
                    />
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="stud_list!=''">
                <!-- {{stud_list}} -->
                <v-col cols="12" sm="3" md="3" v-for="s in stud_list" :key="s.id">
                    <v-card class="box" elevation="10">
                        <center>
                         <span v-if="s.photo!=null">
                        <img :src="awspath + s.photo" style="width: 50px; height: 50px;" alt="logo" />
                    </span>
                     <span v-else>
                        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg" style="width: 50px; height: 50px;" alt="logo" />
                    </span>
                     <h5>PRN No.  {{s.registration_number}}</h5> 
                        <h5>Name : {{s.name}}</h5> 
                        <h5>Standard : {{s.standard}} Div : {{s.division}}</h5> 
                         <v-btn small class="button">Fetch / Generate Report</v-btn>
                        </center>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
       
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                default_value:[],
                dialog_marks:false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                name: null,
                dob: null,
                roll_no: null,
                mobile_no: null,
                address: null,
                mother_name: null,
                photo: null,
                reg_no: null,
                father_full_name: null,
                leraner_marksheet: [],
                semester: null,
                colspan: null,
                overall_grade:null,
                remark:[],
                awspath: "",
            };
        },

        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                this.stud_list = [],
                this.registration_no = null
                axios
                    .post("/ZealExamination/getChildInfo")
                    .then((res) => {
                        if (res.data.msg == "200") {
                           if ((res.data.status = "SUCCESS")) {
                            this.stud_list = res.data.learners;
                        } else {
                            alert(res.data.status_reason);
                        }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                      //  this.semester_list = ["Annual"];
                        // this.sem = "Annual";
                        this.semester_list = res.data.sem_list;
                       // this.semester_list.unshift("Annual");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.awspath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
    thead{
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        .card{
            border: none !important;
             font-size: large !important;
        }
        .pagebreak { page-break-before: always; } 
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead{
            font-weight: bold !important;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    ol.s {list-style-type: inherit;}
</style>
